import { interactionCardConfigSchemaProperties } from './interactionCard'

export const balanceCheckConfigSchema = {
  type: 'object',
  properties: {
    ...interactionCardConfigSchemaProperties
  }
}
